const healthConnectExerciseTypes = {
  BADMINTON: 'Badminton',
  BASEBALL: 'Baseball',
  BASKETBALL: 'Basketball',
  BIKING: 'Fahrrad/Velo fahren',
  BIKING_STATIONARY: 'Velo fahren (Heimtrainer)',
  BOOT_CAMP: 'Bootcamp',
  BOXING: 'Boxen',
  CALISTHENICS: 'Calisthenics',
  CRICKET: 'Cricket',
  DANCING: 'Tanzen',
  ELLIPTICAL: 'Crosstrainer',
  EXERCISE_CLASS: 'Fitnesskurs',
  FENCING: 'Fechten',
  FOOTBALL_AMERICAN: 'Football',
  FOOTBALL_AUSTRALIAN: 'Australisches Football',
  FRISBEE_DISC: 'Frisbee',
  GOLF: 'Golf',
  GUIDED_BREATHING: 'Geführte Atemübung',
  GYMNASTICS: 'Gymnastik',
  HANDBALL: 'Handball',
  HIGH_INTENSITY_INTERVAL_TRAINING: 'Hochintensives Intervalltraining (HIT)',
  HIKING: 'Wandern',
  ICE_HOCKEY: 'Eishockey',
  ICE_SKATING: 'Eislaufen',
  MARTIAL_ARTS: 'Kampfsport',
  OTHER_WORKOUT: 'Workout',
  PADDLING: 'Paddeln',
  PARAGLIDING: 'Paragleiten',
  PILATES: 'Pilates',
  RACQUETBALL: 'Racquetball',
  ROCK_CLIMBING: 'Klettern',
  ROLLER_HOCKEY: 'Inlinehockey',
  ROWING: 'Rudern',
  ROWING_MACHINE: 'Rudergerät',
  RUGBY: 'Rugby',
  RUNNING: 'Joggen',
  RUNNING_TREADMILL: 'Laufband',
  SAILING: 'Segeln',
  SCUBA_DIVING: 'Tauchen',
  SKATING: 'Skating',
  SKIING: 'Skifahren',
  SNOWBOARDING: 'Snowboarden',
  SNOWSHOEING: 'Schneeschuhlaufen',
  SOCCER: 'Fussball',
  SOFTBALL: 'Softball',
  SQUASH: 'Squash',
  STAIR_CLIMBING: 'Treppensteigen',
  STAIR_CLIMBING_MACHINE: 'Treppensteigergerät',
  STRENGTH_TRAINING: 'Krafttraining',
  STRETCHING: 'Dehnen',
  SURFING: 'Surfen',
  SWIMMING_OPEN_WATER: 'Freiwasserschwimmen',
  SWIMMING_POOL: 'Schwimmen (Becken)',
  TABLE_TENNIS: 'Tischtennis',
  TENNIS: 'Tennis',
  VOLLEYBALL: 'Volleyball',
  WALKING: 'Gehen',
  WATER_POLO: 'Wasserball',
  WEIGHTLIFTING: 'Gewichtheben',
  WHEELCHAIR: 'Rollstuhl',
  YOGA: 'Yoga'
}

export default healthConnectExerciseTypes
